import { render, staticRenderFns } from "./index-b.vue?vue&type=template&id=b3a68a90&scoped=true&"
import script from "./index-b.vue?vue&type=script&lang=js&"
export * from "./index-b.vue?vue&type=script&lang=js&"
import style0 from "./index-b.vue?vue&type=style&index=0&id=b3a68a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a68a90",
  null
  
)

export default component.exports